import Vue from 'vue'
import Vuex from 'vuex'
import project from "./modules/project";
import menu from "./modules/menu";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    project,
    menu
  }
})
